import React from 'react';
import { getI18NMessage } from './../../../i18n/I18N';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Button from '@mui/material/Button';
import UI_CONSTANTS from '../../app/constants/UIConstants';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import AppUtil, { getAppURL } from './../../../utils/AppUtil';
import { loadCaptchaScript, validateCaptcha } from '../actions/LoginActions';

class CredLogin extends React.Component {
    constructor(props) {
        super(props);

        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);

        this.state = {
            passwordVisibily: false,
            captchaError: undefined,
            reCaptchaClientId: undefined,
            locked: "",
            warningLocked: false,
            isEmptyCredential: false,
            username: decodeURIComponent(urlParams.get('username') || '')
        };

        this.onSubmit = this.onSubmit.bind(this);
        this.onInputChange = this.onInputChange.bind(this);
        this.showPassword = this.showPassword.bind(this);
        this.hidePassword = this.hidePassword.bind(this);
        this.authenticateUser = this.authenticateUser.bind(this);
        this.onCredKeyUp = this.onCredKeyUp.bind(this);
        this.validateCaptchaAndLogin = this.validateCaptchaAndLogin.bind(this);
    }

    componentDidMount() {
        if(this.props.captcha) {
            loadCaptchaScript(this.props.captcha.sitekey, this.setState.bind(this));
        }
    }

    render() {
        const { passwordVisibily, captchaError, locked, warningLocked, isEmptyCredential } = this.state;
        const { appUrlHash, captcha } = this.props;
        const visiblePasswordProps = {
            InputProps: {
                endAdornment: <Visibility onClick={ this.hidePassword } />
            }
        }
        const hiddenPasswordProps = {
            type: 'password',
            InputProps: {
                endAdornment: <VisibilityOff onClick={ this.showPassword } />
            }
        }
        const passwordProps = passwordVisibily ? visiblePasswordProps : hiddenPasswordProps;
        const invalidCreds = Boolean(appUrlHash && appUrlHash.indexOf(UI_CONSTANTS.INVALID_URL_HASH) !== -1) || isEmptyCredential;
        
        return (
            <form id='sso-form-login' onSubmit={ this.onSubmit }
                action='/rest/v1/auth/login' method='post'>
                
                <FormControl className='lg-username'>
                    <TextField size='small' label={ getI18NMessage('loginid') } 
                        name='username' fullWidth autoFocus 
                        onChange={ this.onInputChange } onBlur={ this.onInputChange } 
                        error={ invalidCreds } onKeyUp={ this.onCredKeyUp }
                        value={this.state.username}
                    />
                    {
                        invalidCreds &&
                            <FormHelperText>{ getI18NMessage('invalidcreds') }</FormHelperText>
                    }
                </FormControl> 
                <TextField size='small' label={ getI18NMessage('password') } fullWidth 
                    name='password' onChange={ this.onInputChange } 
                    onBlur={ this.onInputChange } className='lg-pwd-input'
                    error={ invalidCreds } { ...passwordProps } onKeyUp={ this.onCredKeyUp } />
                {
                    captcha && 
                        <FormControl error={Boolean(captchaError)}>
                            <div className="captcha_wraper" id="captcha_wraper"></div>
                            { captchaError && <FormHelperText>{captchaError}</FormHelperText> }
                        </FormControl>
                }
                {
                    locked &&
                    <FormControl error={Boolean(warningLocked)}>
                        { locked && <FormHelperText>{ locked }</FormHelperText> }
                    </FormControl>
                }
                <div className='lg-form-actions'>
                    {
                        this.props.config.properties.rememberme &&
                            <FormControlLabel control={ <Checkbox size='small' name='rememberMe' /> }
                                label={ getI18NMessage('rememberme') }
                            />
                    }
                    {
                        this.props.config.properties.forgotpassword &&
                            <a href={ UI_CONSTANTS.FORGOT_PW_URL_HASH }>{ getI18NMessage('forgotpassword') }</a>
                    }
                </div>
                <div className='lg-form-buttons'>
                    <Button variant="contained" id="lg-cred-for-submit"
                        onClick={ captcha ? this.validateCaptchaAndLogin : this.authenticateUser }>
                        { getI18NMessage('login') }
                    </Button>
                </div>
                <a id='lg-navigate-invalid-cred' href={ UI_CONSTANTS.INVALID_URL_HASH } className='lg-form-hidden' />
                <a id='lg-navigate-account-lockout' href={ UI_CONSTANTS.ACCOUNT_LOCKOUT } className='lg-form-hidden' />
                <a id='lg-navigate-multiple-account' href={ UI_CONSTANTS.MULTIPLE_ACCOUNT } className='lg-form-hidden' />
                </form>
        )
    }

    onInputChange(event) {
        this.setState({
            [event.target.name]: event.target.value
        })
    }

    hidePassword() {
        this.setState({
            passwordVisibily: false
        })
    }

    showPassword() {
        this.setState({
            passwordVisibily: true
        })
    }


    onSubmit() {
        return true;
    }

    onCredKeyUp(event) {
        if ( event.keyCode === 13 ) {
            document.getElementById('lg-cred-for-submit').click();
        }
    }

    validateCaptchaAndLogin() {
        const { reCaptchaClientId } = this.state;

        validateCaptcha(reCaptchaClientId, "Login", this.setState.bind(this), this.authenticateUser);
    }

    authenticateUser() {
        const URL = getAppURL('AUTHENTICATE_USER');
        const username = (this.state.username || '').trim();
        const password = (this.state.password || '').trim();

        if ( !username || !password ) {
            this.setState({
                isEmptyCredential: true
            });
        } else {
            this.setState({
                isEmptyCredential: false
            });

            AppUtil.ajax( URL, {
                username,
                password
            }, async response => {
                if ( response.status === 401 ) {
                    this.setState({
                        locked: ""
                    })
    
                    document.getElementById('lg-navigate-invalid-cred').click();
                } else if(response.status === 403 || response.status === 429){
                    const responseJson = await response.json();
    
                    this.setState({
                        warningLocked: true,
                        locked: responseJson.message
                    })
    
                    document.getElementById('lg-navigate-account-lockout').click();
                } else {
                    const authenticateResposne = await response.json();
    
                    if ( authenticateResposne.accounts && authenticateResposne.accounts.length > 1 ) {
                        this.props.parentStateUpdate({
                            accounts: authenticateResposne.accounts,
                            username: this.state.username,
                            password: this.state.password
                        });
                        document.getElementById('lg-navigate-multiple-account').click();
                    } else {
                        document.getElementById('sso-form-login').submit();
                    }
                }
            }, () => {
                document.getElementById('lg-navigate-invalid-cred').click();
            }, true );
        }
    }
}

export default CredLogin;
